import { IconBell, IconBellOff } from '@tabler/icons-react';
import { useNotificationSettings, useVeltEventCallback } from '@veltdev/react';
import { useEffect } from 'react';
import SidebarActionButton from 'ui-component/DetailLayout/SidebarComponents/SidebarActionButton';

enum NotificationSettingValues {
  ALL = 'ALL',
  MINE = 'MINE',
  NONE = 'NONE',
}

const initialSettings = [
  {
    name: 'Email',
    id: 'email',
    default: NotificationSettingValues.MINE,
    enable: true,
    values: [
      {
        name: NotificationSettingValues.ALL,
        id: NotificationSettingValues.ALL,
      },
      {
        name: NotificationSettingValues.MINE,
        id: NotificationSettingValues.MINE,
      },
      {
        name: NotificationSettingValues.NONE,
        id: NotificationSettingValues.NONE,
      },
    ],
  },
  {
    name: 'Inbox',
    id: 'inbox',
    default: NotificationSettingValues.MINE,
    enable: true,
    values: [
      {
        name: NotificationSettingValues.ALL,
        id: NotificationSettingValues.ALL,
      },
      {
        name: NotificationSettingValues.MINE,
        id: NotificationSettingValues.MINE,
      },
      {
        name: NotificationSettingValues.NONE,
        id: NotificationSettingValues.NONE,
      },
    ],
  },
];

const VeltSidebarSubscribeActionButton = () => {
  const documentInitEvent = useVeltEventCallback('documentInit');
  const { setSettingsInitialConfig, setSettings, settings } =
    useNotificationSettings();

  useEffect(() => {
    if (documentInitEvent && setSettingsInitialConfig) {
      setSettingsInitialConfig(initialSettings);
    }
  }, [setSettingsInitialConfig, documentInitEvent]);

  return (
    <SidebarActionButton
      Icon={
        settings?.email === NotificationSettingValues.ALL
          ? IconBellOff
          : IconBell
      }
      label={
        settings?.email === NotificationSettingValues.ALL
          ? 'Unsubscribe'
          : 'Subscribe'
      }
      tooltip={
        settings?.email === NotificationSettingValues.ALL
          ? 'Unsubscribe from notifications for this record'
          : 'Subscribe to all notifications for this record'
      }
      onClick={() => {
        if (settings?.email === NotificationSettingValues.ALL) {
          setSettings({
            email: NotificationSettingValues.NONE,
            inbox: NotificationSettingValues.NONE,
          });
        } else {
          setSettings({
            email: NotificationSettingValues.ALL,
            inbox: NotificationSettingValues.ALL,
          });
        }
      }}
    />
  );
};

export default VeltSidebarSubscribeActionButton;
